import { styled } from '@mui/material';
import { up } from '../../../theme';

export const classes = {
  root: 'root',
  MainBox: 'MainBox',
  adminDashboardTitleBox: 'adminDashboardTitleBox',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.MainBox}`]: {
    overflow: 'auto',
    height: `calc(100vh - ${theme.spacing(6)});`,
    '&::-webkit-scrollbar': {
      width: 0,
    },
    [up('xs')]: {
      padding: '20px 14px',
    },
    [up('sm')]: {
      padding: '20px 16px',
    },
    [up('md')]: {
      padding: '23px 18px',
    },
    [up('lg')]: {
      padding: '25px 20px',
    },
    [up('xl')]: {
      padding: '30px 23px',
    },
    [up('xxl')]: {
      padding: '35px 25px',
    },
  },
  [`& .${classes.adminDashboardTitleBox}`]: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '2vh',
  },
}));
